import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,[_c(VCol,{attrs:{"sm":"12","lg":"4"}},[_c('ConformityCard',{attrs:{"minion_id":_vm.minion_id,"conformity":_vm.conformity,"custom_conformity":_vm.custom_conformity}})],1),_c(VCol,{attrs:{"sm":"12","lg":"8"}},[_c('ConformityDetailCard',{attrs:{"succeeded":_vm.succeeded,"unchanged":_vm.unchanged,"failed":_vm.failed}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }